import { render, staticRenderFns } from "./UserCardRightsCustomer.vue?vue&type=template&id=32fe6845&scoped=true&"
import script from "./UserCardRightsCustomer.vue?vue&type=script&lang=ts&"
export * from "./UserCardRightsCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe6845",
  null
  
)

export default component.exports